/* eslint-disable @typescript-eslint/no-explicit-any */
import { SVGProps } from 'react'

const CgArrowsExpandLeft = (props: SVGProps<any>) => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth={0}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1005 4.10052V2.10052H2.10046L2.10046 10.1005H4.10046L4.10046 5.51471L9.87875 11.293L11.293 9.87878L5.51471 4.10052H10.1005Z"
        fill="currentColor"
      ></path>
      <path
        d="M19.8995 13.8995H21.8995V21.8995H13.8995V19.8995H18.4853L12.7071 14.1212L14.1213 12.707L19.8995 18.4853V13.8995Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export default CgArrowsExpandLeft
